// extracted by mini-css-extract-plugin
export default {"container":"iconsDock_container__SWifv","dock1":"iconsDock_dock1__DTzlE","dock2":"iconsDock_dock2__Rakxg","icon":"iconsDock_icon__qKdUC","tooltip":"iconsDock_tooltip__u9Ad5"};